import { render, staticRenderFns } from "./uplodeInput3.vue?vue&type=template&id=da84e496&scoped=true&"
import script from "./uplodeInput3.vue?vue&type=script&lang=js&"
export * from "./uplodeInput3.vue?vue&type=script&lang=js&"
import style0 from "./uplodeInput3.vue?vue&type=style&index=0&id=da84e496&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84e496",
  null
  
)

export default component.exports